import React, { useMemo } from "react";
import { List, Button, Tabs, Grid } from "antd";
import { SoundFilled } from "@ant-design/icons";
import { conversations, IConversation } from "../data/database";
import { useTTS } from "../hooks/useTTS";

const { useBreakpoint } = Grid;

const Conversation: React.FC = () => {
  const { playAudio } = useTTS();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const scenarios = useMemo(() => {
    return Array.from(new Set(conversations.map((c) => c.scenario || "Khác")));
  }, []);

  const items = scenarios.map((scenario) => {
    const scenarioData = conversations.filter(
      (c) => (c.scenario || "Khác") === scenario
    );

    return {
      key: scenario,
      label: (
        <span
          style={{
            fontFamily: "Kanit",
            fontSize: isMobile ? "14px" : "16px",
            padding: isMobile ? "0 4px" : "0 8px",
          }}
        >
          {scenario}
        </span>
      ),
      children: (
        <div
          style={{
            background: "#f8f9fa",
            padding: isMobile ? "12px" : "24px",
            borderRadius: isMobile ? "16px" : "24px",
            maxHeight: "600px",
            overflowY: "auto",
            marginTop: 8,
          }}
        >
          <List
            itemLayout="horizontal"
            dataSource={scenarioData}
            split={false}
            renderItem={(item: IConversation) => {
              const isUserA = item.role === "A";
              return (
                <List.Item
                  style={{
                    display: "flex",
                    flexDirection: isUserA ? "row" : "row-reverse",
                    padding: "8px 0",
                    border: "none",
                  }}
                >
                  {/* Chat Bubble */}
                  <div
                    style={{
                      maxWidth: isMobile ? "85%" : "70%", // Mobile bong bóng to hơn
                      display: "flex",
                      flexDirection: "column",
                      alignItems: isUserA ? "flex-start" : "flex-end",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: 4,
                        fontSize: "12px",
                        color: "#adb5bd",
                        fontWeight: 600,
                        fontFamily: "Kanit",
                        padding: "0 4px",
                      }}
                    >
                      {item.speaker}
                    </div>

                    <div
                      style={{
                        background: isUserA
                          ? "#ffffff"
                          : "linear-gradient(135deg, #FF9A8B 0%, #FF6A88 100%)",
                        color: isUserA ? "#2d3436" : "#ffffff",
                        padding: isMobile ? "12px 16px" : "16px 24px",
                        borderRadius: isUserA
                          ? "4px 24px 24px 24px"
                          : "24px 4px 24px 24px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                        position: "relative",
                      }}
                    >
                      {/* Text Thái */}
                      <div
                        style={{
                          fontSize: isMobile ? "1.1rem" : "1.2rem",
                          fontWeight: 500,
                          marginBottom: 6,
                          lineHeight: 1.5,
                          fontFamily: "Kanit",
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                          flexWrap: "wrap",
                        }}
                      >
                        {item.thai}
                        <Button
                          type="text"
                          shape="circle"
                          size="small"
                          icon={
                            <SoundFilled
                              style={{
                                color: isUserA ? "#FF6A88" : "white",
                                fontSize: "16px",
                              }}
                            />
                          }
                          onClick={() => playAudio(item.thai)}
                        />
                      </div>

                      {/* Text Việt */}
                      <div
                        style={{
                          fontSize: isMobile ? "0.9rem" : "0.95rem",
                          opacity: isUserA ? 0.7 : 0.9,
                          fontFamily: "Kanit",
                          fontStyle: "italic",
                        }}
                      >
                        {item.vietnamese}
                      </div>
                    </div>
                  </div>
                </List.Item>
              );
            }}
          />
        </div>
      ),
    };
  });

  return (
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <div style={{ textAlign: "center", marginBottom: isMobile ? 24 : 32 }}>
        <h2
          style={{
            fontFamily: "Kanit",
            color: "#495057",
            fontWeight: 700,
            fontSize: isMobile ? "1.6rem" : "2rem",
            marginBottom: 8,
            lineHeight: 1.3,
          }}
        >
          Luyện tập Hội thoại 💬
        </h2>
        <p
          style={{
            color: "#868e96",
            fontSize: isMobile ? "1rem" : "1.1rem",
            fontFamily: "Kanit",
          }}
        >
          Luyện nghe và nói theo các tình huống thực tế
        </p>
      </div>

      <Tabs
        defaultActiveKey={scenarios[0]}
        items={items}
        type="card" // Mobile dùng line hoặc card nhỏ
        centered
        size={isMobile ? "small" : "large"}
        tabBarStyle={{
          marginBottom: 16,
          fontFamily: "Kanit",
        }}
      />
    </div>
  );
};

export default Conversation;
